// extracted by mini-css-extract-plugin
export default {"root":"GDPRPanel-module-root","container":"GDPRPanel-module-container","text":"GDPRPanel-module-text","dismiss":"GDPRPanel-module-dismiss"};